import { Box, ChakraProvider } from "@chakra-ui/react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import theme from "./theme";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Tokenomics from "./components/Tokenomics";
import Roadmap from "./components/Roadmap";
import Footer from "./components/Footer";
import HowItWorks from "./components/HowItWorks";
import EarlyAccess from "./pages/EarlyAccess";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const ExternalAppRedirect = ({ mode }: { mode?: "signup" }) => {
  useEffect(() => {
    const target = mode
      ? `https://app.joinvgs.com/login?mode=${mode}`
      : "https://app.joinvgs.com/login";
    window.location.replace(target);
  }, []);

  return null;
};

const HomePage = () => {
  return (
    <Box>
      <Hero />
      <HowItWorks />
      <Features />
      <Tokenomics />
      <Roadmap />
      <Footer />
    </Box>
  );
};

function App() {
  useEffect(() => {
    try {
      AOS.init({
        duration: 1000,
        once: true,
      });
    } catch (error) {
      console.error("Error initializing AOS:", error);
    }
  }, []);

  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route
            path="/signup"
            element={<ExternalAppRedirect mode="signup" />}
          />
          <Route path="/login" element={<ExternalAppRedirect />} />
          <Route path="/early-access" element={<EarlyAccess />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </Router>
    </ChakraProvider>
  );
}

export default App;
